import React from 'react'
import ServiceButton from "../commanfile/ServiceButton"
import health1 from "../Images/DEPRESSION.jpg"
import health2 from "../Images/biapolardisorder2.png"
import health3 from "../Images/ANXIETY DISORDER.png"
import health4 from "../Images/TRAUMA 2.png"
import health5 from "../Images/PSYCOSIS.png"
import health6 from "../Images/FOBIA.png"
import health8 from "../Images/SLEEP DISORDER 2.png"
import health9 from "../Images/ADHD.png"
import health10 from "../Images/ADJESTMENT DISORDER 2.png"
import health11 from "../Images/LGBTQ.png"
import health12 from "../Images/BIMD.png"
import health14 from "../Images/EATING DISORDER 2.png"
import health15 from "../Images/GRIEF 2.png"
import health16 from "../Images/PERSONALITY DISORDER.png"
import health17 from "../Images/OCD.png"

const Iconehelthpage = () => {
  return (
   <>
   <div className='mx-auto py-2'>
    <div className=''>
      <p className='font-roboto sm:text-2xl  text-xl mx-auto  font-semibold  capitalize text-center'>  Focused on mental well-being, Dr. Anant treats multiple psychological conditions with care.</p>
    </div>

<div className="sm:flex sm:flex-wrap  pt-3 ">
            <ServiceButton images={health1} name={"Depression"} />
            <ServiceButton images={health2} name={"Bipolar Disorder"} />
            <ServiceButton images={health3} name={"Anxiety"} />
            <ServiceButton images={health4} name={"Trauma"} />
            <ServiceButton images={health5} name={"Psychosis"} />
            <ServiceButton images={health6} name={"Phobia"} />
            <ServiceButton images={health8} name={"Sleep disorder"} />
            <ServiceButton images={health9} name={"ADHD"} />
            <ServiceButton images={health10} name={"Adjestment disorder"} />
            <ServiceButton images={health11} name={"LGBTQ"} />
            <ServiceButton images={health12} name={"BIMD"} />
            <ServiceButton images={health14} name={"Eating disorder"} />
            <ServiceButton images={health15} name={"GRIEF "} />
            <ServiceButton images={health16} name={"Personality disorder"} />
            <ServiceButton images={health17} name={"OCD"}/>
          </div>
   </div>
   
   </>
  )
}

export default Iconehelthpage